module.exports = __webpack_public_path__ + "img/couples-066.ee7aeba5.jpg";